import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, useAttrs, useListeners } from 'vue';
import { capitalize, lowerCase } from 'lodash';
import {
  PaginatedQuery,
  ClientInvite,
  ClientInviteListFilters,
  ClientInviteState,
  ListQuery,
  ExportListType,
} from 'ah-api-gateways';
import { defineUseManagedListingProps, useManagedListing, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { useServices } from 'bd-common/src/services';
import { invitedClientsTableFields } from './inviteClientsListingTableFields';
import ClientInviteStatusPill from './ClientInviteStatusPill.vue';

interface InvitedClientEmits extends UseManagedListingEmits<ClientInvite> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'InvitedClientsListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    default: () => ({ tableFields: invitedClientsTableFields }),
  },
  ...defineUseManagedListingProps<ClientInvite>(),
},
  setup(__props, { expose, emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;



const services = useServices();
const attrs = useAttrs();
const listeners = useListeners();

const reminderTooltipContent = '<h6>Due a Reminder</h6>Over 2 weeks since the <br> invite was sent out';



const managedListing = useManagedListing<ClientInvite>({
  loadDataRequest(query: PaginatedQuery<ClientInviteListFilters>) {
    return services.clientInvites.listClientInvites(query);
  },
  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager: useRequestManager().manager,
  downloadDataRequest(type, query: ListQuery<ClientInviteListFilters>) {
    return services.clientInvites.downloadClientInvitesReport(query, type as ExportListType);
  },
});

expose({ loadData: managedListing.loadData });

function formatCompanyType(companyType: string): string {
  let formattedCompanyType = lowerCase(companyType).replace(/_/g, ' ');
  formattedCompanyType = formattedCompanyType.replace(/\b\w/g, (char) => capitalize(char));
  return formattedCompanyType;
}

return { __sfc: true,props, services, attrs, listeners, reminderTooltipContent, emit, managedListing, formatCompanyType, ClientInviteState, formatDate, ClientInviteStatusPill }
}

})